import { MerchantId, SetHeaderService } from "@/helper/authenticationHelper";
import {
  BeamRequestModel,
  ChillPayRequestModel,
  PaySolutionRequestModel,
  QRCodePaymentModel,
} from "@/model/payment/paymentModel";
import service from "../baseHttpService";

class MerchantService {
  DoGetMerchantDetail() {
    const _input = {
      merchantId: MerchantId(),
    };
    return service.peakOnlineView
      .post("/api/Merchant/GetDocumentMerchantDetail", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetMerchantAddressList() {
    const _input = {};
    return service.peakRealTimeAPI
      .post("/api/Merchant/GetMerchantAddressListForOnlineViewDocument", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetQRPaymentSetting() {
    const _input = {
      merchantId: MerchantId(),
    };
    return service.peakRealTimeAPI.post("/api/Merchant/GetQRPaymentSetting", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoGetSCBQRCodePayment(input: QRCodePaymentModel) {
    const _input = {
      merchantId: MerchantId(),
      data: input,
    };
    return service.peakAppConnect.post("/api/SCB/GetSCBQRCodePayment", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoGetBayQRCodePayment(input: QRCodePaymentModel) {
    const _input = {
      merchantId: MerchantId(),
      data: input,
    };
    return service.peakAppConnect.post("/api/Bay/GetBayQRCodePayment", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoGetBblQRCodePayment(input: QRCodePaymentModel) {
    const _input = {
      merchantId: MerchantId(),
      data: input,
    };
    return service.peakAppConnect.post("/api/Bbl/GetBblQRCodePayment", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoGetPaySolutionPayment(input: PaySolutionRequestModel) {
    const _input = {
      merchantId: MerchantId(),
      data: input,
    };
    return service.peakAppConnect
      .post("/api/PaySolution/GetPaySolutionPayment", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetBeamPayment(input: BeamRequestModel) {
    const _input = {
      merchantId: MerchantId(),
      data: input,
    };
    return service.peakAppConnect.post("/api/Beam/GetBeamPayment", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoGetChillPayPayment(input: ChillPayRequestModel) {
    const _input = {
      merchantId: MerchantId(),
      data: input,
    };
    return service.peakAppConnect.post("/api/ChillPay/GetChillPayPayment", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
}

export default new MerchantService();
